import React, {FC} from 'react'
import {KTIcon} from '../../../helpers'
import {Item1} from '../../content/adeja/Item1'
import {Item2} from '../../content/adeja/Item2'
import {Item3} from '../../content/adeja/Item3'
import {Item4} from '../../content/adeja/Item4'
import {Item5} from '../../content/adeja/Item5'
import {Item6} from '../../content/adeja/Item6'
import {Item7} from '../../content/adeja/Item7'
import {Item8} from '../../content/adeja/Item8'

const AdjuntoTapua: FC = () => (
  <div
    id='kt_activities10'
    className='bg-body'
    data-kt-drawer='true'
    data-kt-drawer-name='activities10'
    data-kt-drawer-activate='true'
    data-kt-drawer-overlay='true'
    data-kt-drawer-width="{default:'300px', 'lg': '900px'}"
    data-kt-drawer-direction='end'
    data-kt-drawer-toggle='#kt_activities_toggle10'
    data-kt-drawer-close='#kt_activities_close10'
  >
    <div className='card shadow-none rounded-0'>
      <div className='card-header' id='kt_activities_header10'>
        <h3 className='card-title fw-bolder text-dark'>Adjunto Tapua</h3>

        <div className='card-toolbar'>
          <button
            type='button'
            className='btn btn-sm btn-icon btn-active-light-primary me-n5'
            id='kt_activities_close10'
          >
            <KTIcon iconName='cross' className='fs-1' />
          </button>
        </div>
      </div>
      <div className='card-body position-relative' id='kt_activities_body10'>
        <div
          id='kt_activities_scroll10'
          className='position-relative scroll-y me-n5 pe-5'
          data-kt-scroll='true'
          data-kt-scroll-height='auto'
          data-kt-scroll-wrappers='#kt_activities_body10'
          data-kt-scroll-dependencies='#kt_activities_header10, #kt_activities_footer10'
          data-kt-scroll-offset='5px'
        >
          <div className='timeline'>
            <Item1 />
            <Item2 />
            <Item3 />
            <Item4 />
            <Item5 />
            <Item6 />
            <Item7 />
            <Item8 />
          </div>
        </div>
      </div>
    </div>
  </div>
)

export {AdjuntoTapua}
